import React from "react";
import { Card, Button } from "react-bootstrap";
import { IconPlus } from "@tabler/icons-react";
import { getStatusConfig } from "../utils/statusUtils";

const VehicleInfoCard = ({
  vehicle,
  vehicleStatus,
  atvStatuses,
  // updatingStatus,
  // onStatusChange,
  onAddService,
}) => {
  const statusConfig = getStatusConfig(vehicleStatus, atvStatuses.data);

  return (
    <Card>
      <Card.Header>
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            margin: "0",
            color: "#1f2937",
          }}
        >
          Info Dasar Kendaraan
        </h3>
      </Card.Header>
      <Card.Body>
        {/* Vehicle Image Placeholder */}
        <div
          style={{
            height: "120px",
            backgroundColor: "#f3f4f6",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "24px",
            border: `2px solid ${statusConfig.color}`,
          }}
        >
          <span
            style={{
              fontSize: "50px",
              fontWeight: "bold",
              color: "#1f2937",
              padding: "12px 24px",
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              letterSpacing: "2px",
            }}
          >
            {vehicle.plate_number}
          </span>
        </div>

        <div style={{ marginBottom: "24px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>Model:</span>
            <span style={{ fontWeight: "500" }}>{vehicle.model}</span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>Tahun:</span>
            <span style={{ fontWeight: "500" }}>{vehicle.year}</span>
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>No. Rangka:</span>
            <span
              style={{
                fontWeight: "500",
                fontSize: "12px",
                wordBreak: "break-all",
              }}
            >
              {vehicle.chassis_number}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>No. Mesin:</span>
            <span
              style={{
                fontWeight: "500",
                fontSize: "12px",
                wordBreak: "break-all",
              }}
            >
              {vehicle.engine_number}
            </span>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>ATV Validity:</span>
            <span style={{ fontWeight: "500" }}>
              {vehicle.atv_validity} tahun
            </span>
          </div>
        </div>

        <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: "24px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>Service Terakhir:</span>
            <span style={{ fontWeight: "500", color: statusConfig.color }}>
              {vehicle.last_service
                ? new Date(vehicle.last_service).toLocaleDateString("id-ID")
                : "Belum pernah service"}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>Service Berikutnya:</span>
            <span style={{ fontWeight: "500", color: statusConfig.color }}>
              {vehicle.next_service
                ? new Date(vehicle.next_service).toLocaleDateString("id-ID")
                : "Belum dijadwalkan"}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ marginTop: "24px" }}>
          <Button
            style={{
              width: "100%",
              marginBottom: "8px",
              backgroundColor: statusConfig.color,
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
            onClick={onAddService}
          >
            <IconPlus size={16} />
            Service Baru
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default VehicleInfoCard;
